/*
 * @Author: caoyingming 1046659469@qq.com
 * @Date: 2022-07-19 13:43:53
 * @LastEditors: caoyingming 1046659469@qq.com
 * @LastEditTime: 2022-08-22 09:34:24
 * @FilePath: /genetron-web/genetron-h5/src/views/reportQuery/components/component.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ByClass from "@/components/template/reportIndex825/byClass.vue";
import geneVariationFx from "@/components/template/reportIndex825/geneVariationFx.vue";
import geneVariationDrugs from "@/components/template/reportIndex825/geneVariationDrugs.vue";
import MyzlTips from "@/components/template/reportIndex825/myzlTips.vue";
import YcygVariation from "@/components/template/reportIndex825/ycygVariation.vue";
import HlywTips from "@/components/template/reportIndex825/hlywTips.vue";
import variationTest from "@/components/template/reportIndex825/variationTest.vue";
import cancerVariation from "@/components/template/reportIndex825/cancerVariation.vue";
import ImportantGene from "@/components/template/reportIndex825/importantGene.vue";
/**脑13系列组件 */
import SingleNucleotide from "@/components/template/brain13/singleNucleotide.vue";
import MethylaTion from "@/components/template/brain13/methylaTion.vue";
import CnvResult from "@/components/template/brain13/cnvResult.vue";
import RnvResult from "@/components/template/brain13/rnvResult.vue";
import Testing from "@/components/template/brain13/testing.vue";
// all
import MutationList from "@/components/template/All/mutationList825.vue";
import Typing from "@/components/template/All/Typing.vue";
import Ramucirumab from "@/components/template/All/Ramucirumab.vue";
import Appendix from "@/components/template/All/Appendix.vue";
import Dpart from "@/components/template/All/Dpart.vue";
import ZlAssess from "@/components/template/All/ZlAssess.vue";
import Typingtips from "@/components/template/All/Typingtips.vue";
import Alk from "@/components/template/All/Alk.vue";
import Reference from "@/components/template/All/Reference.vue";
import Quills from "@/components/template/All/Quills.vue";
import newYcygVariation from "./index/newYcygVariation.vue";

import kepipei from "@/components/template/All/kepipei.vue";


const Components = {
    ByClass,
    MyzlTips,
    YcygVariation,
    HlywTips,
    SingleNucleotide,
    MethylaTion,
    CnvResult,
    RnvResult,
    Testing,
    MutationList,
    Typing,
    Ramucirumab,
    Appendix,
    Dpart,
    ZlAssess,
    Typingtips,
    Alk,
    Reference,
    newYcygVariation,
    Quills,
    ImportantGene,
    kepipei,
    geneVariationFx,
    geneVariationDrugs,
    cancerVariation,
    variationTest
}
export {
    Components
}